import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    { 
      id: 'EUR',
      name: i18n.t('tipos.moneda.eur'),
    },
    { 
      id: 'USD',
      name: i18n.t('tipos.moneda.usd'),
    },
    { 
      id: 'AFN',
      name: i18n.t('tipos.moneda.afn'),
    },
    { 
      id: 'ALL',
      name: i18n.t('tipos.moneda.all'),
    },
    { 
      id: 'AMD',
      name: i18n.t('tipos.moneda.amd'),
    },
    { 
      id: 'ANG',
      name: i18n.t('tipos.moneda.ang'),
    },
    { 
      id: 'AOA',
      name: i18n.t('tipos.moneda.aoa'),
    },
    { 
      id: 'ARS',
      name: i18n.t('tipos.moneda.ars'),
    },
    { 
      id: 'AUD',
      name: i18n.t('tipos.moneda.aud'),
    },
    { 
      id: 'AWG',
      name: i18n.t('tipos.moneda.awg'),
    },
    { 
      id: 'AZN',
      name: i18n.t('tipos.moneda.azn'),
    },
    { 
      id: 'BAD',
      name: i18n.t('tipos.moneda.bad'),
    },
    { 
      id: 'BBD',
      name: i18n.t('tipos.moneda.bbd'),
    },
    { 
      id: 'BDT',
      name: i18n.t('tipos.moneda.bdt'),
    },
    { 
      id: 'BGN',
      name: i18n.t('tipos.moneda.bgn'),
    },
    { 
      id: 'BHD',
      name: i18n.t('tipos.moneda.bhd'),
    },
    { 
      id: 'BIF',
      name: i18n.t('tipos.moneda.bif'),
    },
    { 
      id: 'BMD',
      name: i18n.t('tipos.moneda.bmd'),
    },
    { 
      id: 'BND',
      name: i18n.t('tipos.moneda.bnd'),
    },
    { 
      id: 'BOB',
      name: i18n.t('tipos.moneda.bob'),
    },
    { 
      id: 'BRL',
      name: i18n.t('tipos.moneda.brl'),
    },
    { 
      id: 'BRR',
      name: i18n.t('tipos.moneda.brr'),
    },
    { 
      id: 'BSD',
      name: i18n.t('tipos.moneda.bsd'),
    },
    { 
      id: 'BWP',
      name: i18n.t('tipos.moneda.bwp'),
    },
    { 
      id: 'BYR',
      name: i18n.t('tipos.moneda.byr'),
    },
    { 
      id: 'BZD',
      name: i18n.t('tipos.moneda.bzd'),
    },
    { 
      id: 'CAD',
      name: i18n.t('tipos.moneda.cad'),
    },
    { 
      id: 'CDF',
      name: i18n.t('tipos.moneda.cdf'),
    },
    { 
      id: 'CDP',
      name: i18n.t('tipos.moneda.cdp'),
    },
    { 
      id: 'CHF',
      name: i18n.t('tipos.moneda.chf'),
    },
    { 
      id: 'CLP',
      name: i18n.t('tipos.moneda.clp'),
    },
    { 
      id: 'CNY',
      name: i18n.t('tipos.moneda.cny'),
    },
    { 
      id: 'COP',
      name: i18n.t('tipos.moneda.cop'),
    },
    { 
      id: 'CRC',
      name: i18n.t('tipos.moneda.crc'),
    },
    { 
      id: 'CUP',
      name: i18n.t('tipos.moneda.cup'),
    },
    { 
      id: 'CVE',
      name: i18n.t('tipos.moneda.cve'),
    },
    { 
      id: 'CZK',
      name: i18n.t('tipos.moneda.czk'),
    },
    { 
      id: 'DJF',
      name: i18n.t('tipos.moneda.djf'),
    },
    { 
      id: 'DKK',
      name: i18n.t('tipos.moneda.dkk'),
    },
    { 
      id: 'DOP',
      name: i18n.t('tipos.moneda.dop'),
    },
    { 
      id: 'DRP',
      name: i18n.t('tipos.moneda.drp'),
    },
    { 
      id: 'DZD',
      name: i18n.t('tipos.moneda.dzd'),
    },
    { 
      id: 'EEK',
      name: i18n.t('tipos.moneda.eek'),
    },
    { 
      id: 'EGP',
      name: i18n.t('tipos.moneda.egp'),
    },
    { 
      id: 'ESP',
      name: i18n.t('tipos.moneda.esp'),
    },
    { 
      id: 'ETB',
      name: i18n.t('tipos.moneda.etb'),
    },
    { 
      id: 'FJD',
      name: i18n.t('tipos.moneda.fjd'),
    },
    { 
      id: 'FKP',
      name: i18n.t('tipos.moneda.fkp'),
    },
    { 
      id: 'GBP',
      name: i18n.t('tipos.moneda.gbp'),
    },
    { 
      id: 'GEK',
      name: i18n.t('tipos.moneda.gek'),
    },
    { 
      id: 'GHC',
      name: i18n.t('tipos.moneda.ghc'),
    },
    { 
      id: 'GIP',
      name: i18n.t('tipos.moneda.gip'),
    },
    { 
      id: 'GMD',
      name: i18n.t('tipos.moneda.gmd'),
    },
    { 
      id: 'GNF',
      name: i18n.t('tipos.moneda.gnf'),
    },
    { 
      id: 'GTQ',
      name: i18n.t('tipos.moneda.gtq'),
    },
    { 
      id: 'GWP',
      name: i18n.t('tipos.moneda.gwp'),
    },
    { 
      id: 'GYD',
      name: i18n.t('tipos.moneda.gyd'),
    },
    { 
      id: 'HKD',
      name: i18n.t('tipos.moneda.hkd'),
    },
    { 
      id: 'HNL',
      name: i18n.t('tipos.moneda.hnl'),
    },
    { 
      id: 'HRK',
      name: i18n.t('tipos.moneda.hrk'),
    },
    { 
      id: 'HTG',
      name: i18n.t('tipos.moneda.htg'),
    },
    { 
      id: 'HUF',
      name: i18n.t('tipos.moneda.huf'),
    },
    { 
      id: 'IDR',
      name: i18n.t('tipos.moneda.idr'),
    },
    { 
      id: 'ILS',
      name: i18n.t('tipos.moneda.ils'),
    },
    { 
      id: 'INR',
      name: i18n.t('tipos.moneda.inr'),
    },
    { 
      id: 'IQD',
      name: i18n.t('tipos.moneda.iqd'),
    },
    { 
      id: 'IRR',
      name: i18n.t('tipos.moneda.irr'),
    },
    { 
      id: 'ISK',
      name: i18n.t('tipos.moneda.isk'),
    },
    { 
      id: 'JMD',
      name: i18n.t('tipos.moneda.jmd'),
    },
    { 
      id: 'JOD',
      name: i18n.t('tipos.moneda.jod'),
    },
    { 
      id: 'JPY',
      name: i18n.t('tipos.moneda.jpy'),
    },
    { 
      id: 'KES',
      name: i18n.t('tipos.moneda.kes'),
    },
    { 
      id: 'KGS',
      name: i18n.t('tipos.moneda.kgs'),
    },
    { 
      id: 'KHR',
      name: i18n.t('tipos.moneda.khr'),
    },
    { 
      id: 'KMF',
      name: i18n.t('tipos.moneda.kmf'),
    },
    { 
      id: 'KPW',
      name: i18n.t('tipos.moneda.kpw'),
    },
    { 
      id: 'KRW',
      name: i18n.t('tipos.moneda.krw'),
    },
    { 
      id: 'KWD',
      name: i18n.t('tipos.moneda.kwd'),
    },
    { 
      id: 'KYD',
      name: i18n.t('tipos.moneda.kyd'),
    },
    { 
      id: 'KZT',
      name: i18n.t('tipos.moneda.kzt'),
    },
    { 
      id: 'LAK',
      name: i18n.t('tipos.moneda.lak'),
    },
    { 
      id: 'LBP',
      name: i18n.t('tipos.moneda.lbp'),
    },
    { 
      id: 'LKR',
      name: i18n.t('tipos.moneda.lkr'),
    },
    { 
      id: 'LRD',
      name: i18n.t('tipos.moneda.lrd'),
    },
    { 
      id: 'LSL',
      name: i18n.t('tipos.moneda.lsl'),
    },
    { 
      id: 'LTL',
      name: i18n.t('tipos.moneda.ltl'),
    },
    { 
      id: 'LVL',
      name: i18n.t('tipos.moneda.lvl'),
    },
    { 
      id: 'LYD',
      name: i18n.t('tipos.moneda.lyd'),
    },
    { 
      id: 'MAD',
      name: i18n.t('tipos.moneda.mad'),
    },
    { 
      id: 'MDL',
      name: i18n.t('tipos.moneda.mdl'),
    },
    { 
      id: 'MGF',
      name: i18n.t('tipos.moneda.mgf'),
    },
    { 
      id: 'MNC',
      name: i18n.t('tipos.moneda.mnc'),
    },
    { 
      id: 'MNT',
      name: i18n.t('tipos.moneda.mnt'),
    },
    { 
      id: 'MOP',
      name: i18n.t('tipos.moneda.mop'),
    },
    { 
      id: 'MRO',
      name: i18n.t('tipos.moneda.mro'),
    },
    { 
      id: 'MUR',
      name: i18n.t('tipos.moneda.mur'),
    },
    { 
      id: 'MVR',
      name: i18n.t('tipos.moneda.mvr'),
    },
    { 
      id: 'MWK',
      name: i18n.t('tipos.moneda.mwk'),
    },
    { 
      id: 'MXN',
      name: i18n.t('tipos.moneda.mxn'),
    },
    { 
      id: 'MYR',
      name: i18n.t('tipos.moneda.myr'),
    },
    { 
      id: 'MZM',
      name: i18n.t('tipos.moneda.mzm'),
    },
    { 
      id: 'NGN',
      name: i18n.t('tipos.moneda.ngn'),
    },
    { 
      id: 'NIC',
      name: i18n.t('tipos.moneda.nic'),
    },
    { 
      id: 'NIO',
      name: i18n.t('tipos.moneda.nio'),
    },
    { 
      id: 'NIS',
      name: i18n.t('tipos.moneda.nis'),
    },
    { 
      id: 'NOK',
      name: i18n.t('tipos.moneda.nok'),
    },
    { 
      id: 'NPR',
      name: i18n.t('tipos.moneda.npr'),
    },
    { 
      id: 'NZD',
      name: i18n.t('tipos.moneda.nzd'),
    },
    { 
      id: 'OMR',
      name: i18n.t('tipos.moneda.omr'),
    },
    { 
      id: 'PAB',
      name: i18n.t('tipos.moneda.pab'),
    },
    { 
      id: 'PEI',
      name: i18n.t('tipos.moneda.pei'),
    },
    { 
      id: 'PEN',
      name: i18n.t('tipos.moneda.pen'),
    },
    { 
      id: 'PES',
      name: i18n.t('tipos.moneda.pes'),
    },
    { 
      id: 'PGK',
      name: i18n.t('tipos.moneda.pgk'),
    },
    { 
      id: 'PHP',
      name: i18n.t('tipos.moneda.php'),
    },
    { 
      id: 'PKR',
      name: i18n.t('tipos.moneda.pkr'),
    },
    { 
      id: 'PLN',
      name: i18n.t('tipos.moneda.pln'),
    },
    { 
      id: 'PYG',
      name: i18n.t('tipos.moneda.pyg'),
    },
    { 
      id: 'QAR',
      name: i18n.t('tipos.moneda.qar'),
    },
    { 
      id: 'RMB',
      name: i18n.t('tipos.moneda.rmb'),
    },
    { 
      id: 'RON',
      name: i18n.t('tipos.moneda.ron'),
    },
    { 
      id: 'RUB',
      name: i18n.t('tipos.moneda.rub'),
    },
    { 
      id: 'RWF',
      name: i18n.t('tipos.moneda.rwf'),
    },
    { 
      id: 'SAR',
      name: i18n.t('tipos.moneda.sar'),
    },
    { 
      id: 'SBD',
      name: i18n.t('tipos.moneda.sbd'),
    },
    { 
      id: 'SCR',
      name: i18n.t('tipos.moneda.scr'),
    },
    { 
      id: 'SDP',
      name: i18n.t('tipos.moneda.sdp'),
    },
    { 
      id: 'SEK',
      name: i18n.t('tipos.moneda.sek'),
    },
    { 
      id: 'SGD',
      name: i18n.t('tipos.moneda.sgd'),
    },
    { 
      id: 'SHP',
      name: i18n.t('tipos.moneda.shp'),
    },
    { 
      id: 'SKK',
      name: i18n.t('tipos.moneda.skk'),
    },
    { 
      id: 'SLL',
      name: i18n.t('tipos.moneda.sll'),
    },
    { 
      id: 'SOL',
      name: i18n.t('tipos.moneda.sol'),
    },
    { 
      id: 'SOS',
      name: i18n.t('tipos.moneda.sos'),
    },
    { 
      id: 'SRD',
      name: i18n.t('tipos.moneda.srd'),
    },
    { 
      id: 'STD',
      name: i18n.t('tipos.moneda.std'),
    },
    { 
      id: 'SVC',
      name: i18n.t('tipos.moneda.svc'),
    },
    { 
      id: 'SYP',
      name: i18n.t('tipos.moneda.syp'),
    },
    { 
      id: 'SZL',
      name: i18n.t('tipos.moneda.szl'),
    },
    { 
      id: 'THB',
      name: i18n.t('tipos.moneda.thb'),
    },
    { 
      id: 'TJS',
      name: i18n.t('tipos.moneda.tjs'),
    },
    { 
      id: 'TMM',
      name: i18n.t('tipos.moneda.tmm'),
    },
    { 
      id: 'TND',
      name: i18n.t('tipos.moneda.tnd'),
    },
    { 
      id: 'TOP',
      name: i18n.t('tipos.moneda.top'),
    },
    { 
      id: 'TPE',
      name: i18n.t('tipos.moneda.tpe'),
    },
    { 
      id: 'TRY',
      name: i18n.t('tipos.moneda.try'),
    },
    { 
      id: 'TTD',
      name: i18n.t('tipos.moneda.ttd'),
    },
    { 
      id: 'TWD',
      name: i18n.t('tipos.moneda.twd'),
    },
    { 
      id: 'TZS',
      name: i18n.t('tipos.moneda.tzs'),
    },
    { 
      id: 'UAH',
      name: i18n.t('tipos.moneda.uah'),
    },
    { 
      id: 'UGS',
      name: i18n.t('tipos.moneda.ugs'),
    },
    { 
      id: 'UYP',
      name: i18n.t('tipos.moneda.uyp'),
    },
    { 
      id: 'UYU',
      name: i18n.t('tipos.moneda.uyu'),
    },
    { 
      id: 'VEF',
      name: i18n.t('tipos.moneda.vef'),
    },
    { 
      id: 'VND',
      name: i18n.t('tipos.moneda.vnd'),
    },
    { 
      id: 'VUV',
      name: i18n.t('tipos.moneda.vuv'),
    },
    { 
      id: 'WST',
      name: i18n.t('tipos.moneda.wst'),
    },
    { 
      id: 'XAF',
      name: i18n.t('tipos.moneda.xaf'),
    },
    { 
      id: 'XCD',
      name: i18n.t('tipos.moneda.xcd'),
    },
    { 
      id: 'XOF',
      name: i18n.t('tipos.moneda.xof'),
    },
    { 
      id: 'YER',
      name: i18n.t('tipos.moneda.yer'),
    },
    { 
      id: 'ZAR',
      name: i18n.t('tipos.moneda.zar'),
    },
    { 
      id: 'ZMK',
      name: i18n.t('tipos.moneda.zmk'),
    },
    { 
      id: 'ZWD',
      name: i18n.t('tipos.moneda.zwd'),
    },
  ]
}

export function MONEDA_OPERACION (state) {
  return configHelper.getConfig(state, 'MONEDA_OPERACION', GenerateConfig)
}
